'use client'

import { UserCircleIcon } from '@heroicons/react/24/outline'
import { useContext } from 'react'
import { WidgetAuthContext } from './WidgetAuthProvider'

export default function LoggedInBanner() {
    const { session, logout } = useContext(WidgetAuthContext)

    if (!session) return null

    const { firstName, lastName, email } = session.client
    const fullName = [firstName, lastName].filter(Boolean).join(' ').trim()

    return (
        <div
            className="flex items-center gap-3 px-4 py-2 rounded-lg border widget-border widget-bg-primary-50/40 text-xs widget-text-secondary"
            data-testid="widget-logged-in-banner"
        >
            <UserCircleIcon className="size-5 widget-text-primary-color-500 shrink-0" />
            <span className="flex-1 min-w-0 truncate">
                Angemeldet als <span className="font-medium widget-text-primary">{fullName || email}</span>
                {email && fullName ? ` (${email})` : null}
            </span>
            <button
                type="button"
                onClick={logout}
                className="text-xs underline widget-text-secondary hover:widget-text-primary shrink-0"
                data-testid="widget-logout-button"
            >
                Abmelden
            </button>
        </div>
    )
}
